import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { IIconComponent } from "@front/m19-ui";

@Component({
  selector: "app-sync-info",
  imports: [IIconComponent],
  template: ` <div class="flex items-center gap-2 rounded-md border bg-gray-50 px-2 py-1 text-gray-600">
    <IIcon name="sync" /><span class="text-sm">{{ message() }}</span>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SyncInfoComponent {
  message = input.required<string>();
}
